// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/integration/external_ticketing/v1/external_ticketing.proto" (package "c1.api.external_ticketing.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { JiraConfig } from "../jira/v1/jira";
/**
 * @generated from protobuf message c1.api.external_ticketing.v1.ServiceDeskIntegrationRef
 */
export interface ServiceDeskIntegrationRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.v1.UpdateConfigRequest
 */
export interface UpdateConfigRequest {
    /**
     * @generated from protobuf field: string integration_id = 1
     */
    integrationId: string;
    /**
     * @generated from protobuf oneof: config
     */
    config: {
        oneofKind: "jiraConfig";
        /**
         * @generated from protobuf field: c1.api.external_ticketing.jira.v1.JiraConfig jira_config = 10
         */
        jiraConfig: JiraConfig;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.external_ticketing.v1.UpdateConfigResponse
 */
export interface UpdateConfigResponse {
}
/**
 * @generated from protobuf message c1.api.external_ticketing.v1.DeleteServiceDeskRefRequest
 */
export interface DeleteServiceDeskRefRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.v1.DeleteServiceDeskRefResponse
 */
export interface DeleteServiceDeskRefResponse {
}
/**
 * @generated from protobuf message c1.api.external_ticketing.v1.GetServiceDeskRefRequest
 */
export interface GetServiceDeskRefRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.v1.GetServiceDeskRefResponse
 */
export interface GetServiceDeskRefResponse {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.external_ticketing.v1.ServiceDeskType type = 2
     */
    type: ServiceDeskType;
    /**
     * @generated from protobuf field: string display_name = 3
     */
    displayName: string;
    /**
     * @generated from protobuf field: bool is_bound = 4
     */
    isBound: boolean;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.v1.CreateServiceDeskRefRequest
 */
export interface CreateServiceDeskRefRequest {
    /**
     * @generated from protobuf field: c1.api.external_ticketing.v1.ServiceDeskType type = 1
     */
    type: ServiceDeskType;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.v1.CreateServiceDeskRefResponse
 */
export interface CreateServiceDeskRefResponse {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.v1.GetServiceDeskIntegrationRequest
 */
export interface GetServiceDeskIntegrationRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.v1.GetServiceDeskIntegrationResponse
 */
export interface GetServiceDeskIntegrationResponse {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string base_url = 2
     */
    baseUrl: string;
    /**
     * @generated from protobuf field: string display_name = 3
     */
    displayName: string;
    /**
     * @generated from protobuf field: c1.api.external_ticketing.v1.ServiceDeskType type = 4
     */
    type: ServiceDeskType;
    /**
     * @generated from protobuf oneof: config
     */
    config: {
        oneofKind: "jiraConfig";
        /**
         * @generated from protobuf field: c1.api.external_ticketing.jira.v1.JiraConfig jira_config = 10
         */
        jiraConfig: JiraConfig;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.external_ticketing.v1.ListServiceDeskIntegrationsRequest
 */
export interface ListServiceDeskIntegrationsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.v1.ServiceDeskIntegrationRef refs = 3
     */
    refs: ServiceDeskIntegrationRef[];
}
/**
 * @generated from protobuf message c1.api.external_ticketing.v1.ListServiceDeskIntegrationsResponse
 */
export interface ListServiceDeskIntegrationsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.v1.GetServiceDeskIntegrationResponse list = 1
     */
    list: GetServiceDeskIntegrationResponse[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.v1.UpdateIntegrationNameRequest
 */
export interface UpdateIntegrationNameRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.v1.UpdateIntegrationNameResponse
 */
export interface UpdateIntegrationNameResponse {
}
/**
 * @generated from protobuf message c1.api.external_ticketing.v1.ServiceDeskIntegration
 */
export interface ServiceDeskIntegration {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string base_url = 2
     */
    baseUrl: string;
    /**
     * @generated from protobuf field: c1.api.external_ticketing.v1.ServiceDeskType type = 3
     */
    type: ServiceDeskType;
    /**
     * @generated from protobuf field: string display_name = 4
     */
    displayName: string;
    /**
     * @generated from protobuf oneof: config
     */
    config: {
        oneofKind: "jiraConfig";
        /**
         * @generated from protobuf field: c1.api.external_ticketing.jira.v1.JiraConfig jira_config = 100
         */
        jiraConfig: JiraConfig; // ZohoManageEngineSDPConfig zoho_manage_engine_sdp_config = 101;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf enum c1.api.external_ticketing.v1.ServiceDeskType
 */
export enum ServiceDeskType {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: JIRA = 1;
     */
    JIRA = 1
}
// @generated message type with reflection information, may provide speed optimized methods
class ServiceDeskIntegrationRef$Type extends MessageType<ServiceDeskIntegrationRef> {
    constructor() {
        super("c1.api.external_ticketing.v1.ServiceDeskIntegrationRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ServiceDeskIntegrationRef>): ServiceDeskIntegrationRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<ServiceDeskIntegrationRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ServiceDeskIntegrationRef): ServiceDeskIntegrationRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ServiceDeskIntegrationRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.v1.ServiceDeskIntegrationRef
 */
export const ServiceDeskIntegrationRef = new ServiceDeskIntegrationRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateConfigRequest$Type extends MessageType<UpdateConfigRequest> {
    constructor() {
        super("c1.api.external_ticketing.v1.UpdateConfigRequest", [
            { no: 1, name: "integration_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "jira_config", kind: "message", oneof: "config", T: () => JiraConfig }
        ]);
    }
    create(value?: PartialMessage<UpdateConfigRequest>): UpdateConfigRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.integrationId = "";
        message.config = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<UpdateConfigRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateConfigRequest): UpdateConfigRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string integration_id */ 1:
                    message.integrationId = reader.string();
                    break;
                case /* c1.api.external_ticketing.jira.v1.JiraConfig jira_config */ 10:
                    message.config = {
                        oneofKind: "jiraConfig",
                        jiraConfig: JiraConfig.internalBinaryRead(reader, reader.uint32(), options, (message.config as any).jiraConfig)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateConfigRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string integration_id = 1; */
        if (message.integrationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.integrationId);
        /* c1.api.external_ticketing.jira.v1.JiraConfig jira_config = 10; */
        if (message.config.oneofKind === "jiraConfig")
            JiraConfig.internalBinaryWrite(message.config.jiraConfig, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.v1.UpdateConfigRequest
 */
export const UpdateConfigRequest = new UpdateConfigRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateConfigResponse$Type extends MessageType<UpdateConfigResponse> {
    constructor() {
        super("c1.api.external_ticketing.v1.UpdateConfigResponse", []);
    }
    create(value?: PartialMessage<UpdateConfigResponse>): UpdateConfigResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateConfigResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateConfigResponse): UpdateConfigResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateConfigResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.v1.UpdateConfigResponse
 */
export const UpdateConfigResponse = new UpdateConfigResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteServiceDeskRefRequest$Type extends MessageType<DeleteServiceDeskRefRequest> {
    constructor() {
        super("c1.api.external_ticketing.v1.DeleteServiceDeskRefRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<DeleteServiceDeskRefRequest>): DeleteServiceDeskRefRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<DeleteServiceDeskRefRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteServiceDeskRefRequest): DeleteServiceDeskRefRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteServiceDeskRefRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.v1.DeleteServiceDeskRefRequest
 */
export const DeleteServiceDeskRefRequest = new DeleteServiceDeskRefRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteServiceDeskRefResponse$Type extends MessageType<DeleteServiceDeskRefResponse> {
    constructor() {
        super("c1.api.external_ticketing.v1.DeleteServiceDeskRefResponse", []);
    }
    create(value?: PartialMessage<DeleteServiceDeskRefResponse>): DeleteServiceDeskRefResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteServiceDeskRefResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteServiceDeskRefResponse): DeleteServiceDeskRefResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteServiceDeskRefResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.v1.DeleteServiceDeskRefResponse
 */
export const DeleteServiceDeskRefResponse = new DeleteServiceDeskRefResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetServiceDeskRefRequest$Type extends MessageType<GetServiceDeskRefRequest> {
    constructor() {
        super("c1.api.external_ticketing.v1.GetServiceDeskRefRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<GetServiceDeskRefRequest>): GetServiceDeskRefRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<GetServiceDeskRefRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetServiceDeskRefRequest): GetServiceDeskRefRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetServiceDeskRefRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.v1.GetServiceDeskRefRequest
 */
export const GetServiceDeskRefRequest = new GetServiceDeskRefRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetServiceDeskRefResponse$Type extends MessageType<GetServiceDeskRefResponse> {
    constructor() {
        super("c1.api.external_ticketing.v1.GetServiceDeskRefResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "type", kind: "enum", T: () => ["c1.api.external_ticketing.v1.ServiceDeskType", ServiceDeskType] },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "is_bound", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<GetServiceDeskRefResponse>): GetServiceDeskRefResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.type = 0;
        message.displayName = "";
        message.isBound = false;
        if (value !== undefined)
            reflectionMergePartial<GetServiceDeskRefResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetServiceDeskRefResponse): GetServiceDeskRefResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* c1.api.external_ticketing.v1.ServiceDeskType type */ 2:
                    message.type = reader.int32();
                    break;
                case /* string display_name */ 3:
                    message.displayName = reader.string();
                    break;
                case /* bool is_bound */ 4:
                    message.isBound = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetServiceDeskRefResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* c1.api.external_ticketing.v1.ServiceDeskType type = 2; */
        if (message.type !== 0)
            writer.tag(2, WireType.Varint).int32(message.type);
        /* string display_name = 3; */
        if (message.displayName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.displayName);
        /* bool is_bound = 4; */
        if (message.isBound !== false)
            writer.tag(4, WireType.Varint).bool(message.isBound);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.v1.GetServiceDeskRefResponse
 */
export const GetServiceDeskRefResponse = new GetServiceDeskRefResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateServiceDeskRefRequest$Type extends MessageType<CreateServiceDeskRefRequest> {
    constructor() {
        super("c1.api.external_ticketing.v1.CreateServiceDeskRefRequest", [
            { no: 1, name: "type", kind: "enum", T: () => ["c1.api.external_ticketing.v1.ServiceDeskType", ServiceDeskType] },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreateServiceDeskRefRequest>): CreateServiceDeskRefRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = 0;
        message.displayName = "";
        if (value !== undefined)
            reflectionMergePartial<CreateServiceDeskRefRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateServiceDeskRefRequest): CreateServiceDeskRefRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.external_ticketing.v1.ServiceDeskType type */ 1:
                    message.type = reader.int32();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateServiceDeskRefRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.external_ticketing.v1.ServiceDeskType type = 1; */
        if (message.type !== 0)
            writer.tag(1, WireType.Varint).int32(message.type);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.v1.CreateServiceDeskRefRequest
 */
export const CreateServiceDeskRefRequest = new CreateServiceDeskRefRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateServiceDeskRefResponse$Type extends MessageType<CreateServiceDeskRefResponse> {
    constructor() {
        super("c1.api.external_ticketing.v1.CreateServiceDeskRefResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<CreateServiceDeskRefResponse>): CreateServiceDeskRefResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<CreateServiceDeskRefResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateServiceDeskRefResponse): CreateServiceDeskRefResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateServiceDeskRefResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.v1.CreateServiceDeskRefResponse
 */
export const CreateServiceDeskRefResponse = new CreateServiceDeskRefResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetServiceDeskIntegrationRequest$Type extends MessageType<GetServiceDeskIntegrationRequest> {
    constructor() {
        super("c1.api.external_ticketing.v1.GetServiceDeskIntegrationRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<GetServiceDeskIntegrationRequest>): GetServiceDeskIntegrationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<GetServiceDeskIntegrationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetServiceDeskIntegrationRequest): GetServiceDeskIntegrationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetServiceDeskIntegrationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.v1.GetServiceDeskIntegrationRequest
 */
export const GetServiceDeskIntegrationRequest = new GetServiceDeskIntegrationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetServiceDeskIntegrationResponse$Type extends MessageType<GetServiceDeskIntegrationResponse> {
    constructor() {
        super("c1.api.external_ticketing.v1.GetServiceDeskIntegrationResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "base_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { uri: true } } } },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "type", kind: "enum", T: () => ["c1.api.external_ticketing.v1.ServiceDeskType", ServiceDeskType] },
            { no: 10, name: "jira_config", kind: "message", oneof: "config", T: () => JiraConfig }
        ]);
    }
    create(value?: PartialMessage<GetServiceDeskIntegrationResponse>): GetServiceDeskIntegrationResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.baseUrl = "";
        message.displayName = "";
        message.type = 0;
        message.config = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<GetServiceDeskIntegrationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetServiceDeskIntegrationResponse): GetServiceDeskIntegrationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string base_url */ 2:
                    message.baseUrl = reader.string();
                    break;
                case /* string display_name */ 3:
                    message.displayName = reader.string();
                    break;
                case /* c1.api.external_ticketing.v1.ServiceDeskType type */ 4:
                    message.type = reader.int32();
                    break;
                case /* c1.api.external_ticketing.jira.v1.JiraConfig jira_config */ 10:
                    message.config = {
                        oneofKind: "jiraConfig",
                        jiraConfig: JiraConfig.internalBinaryRead(reader, reader.uint32(), options, (message.config as any).jiraConfig)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetServiceDeskIntegrationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string base_url = 2; */
        if (message.baseUrl !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.baseUrl);
        /* string display_name = 3; */
        if (message.displayName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.displayName);
        /* c1.api.external_ticketing.v1.ServiceDeskType type = 4; */
        if (message.type !== 0)
            writer.tag(4, WireType.Varint).int32(message.type);
        /* c1.api.external_ticketing.jira.v1.JiraConfig jira_config = 10; */
        if (message.config.oneofKind === "jiraConfig")
            JiraConfig.internalBinaryWrite(message.config.jiraConfig, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.v1.GetServiceDeskIntegrationResponse
 */
export const GetServiceDeskIntegrationResponse = new GetServiceDeskIntegrationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListServiceDeskIntegrationsRequest$Type extends MessageType<ListServiceDeskIntegrationsRequest> {
    constructor() {
        super("c1.api.external_ticketing.v1.ListServiceDeskIntegrationsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ServiceDeskIntegrationRef }
        ]);
    }
    create(value?: PartialMessage<ListServiceDeskIntegrationsRequest>): ListServiceDeskIntegrationsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<ListServiceDeskIntegrationsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListServiceDeskIntegrationsRequest): ListServiceDeskIntegrationsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* repeated c1.api.external_ticketing.v1.ServiceDeskIntegrationRef refs */ 3:
                    message.refs.push(ServiceDeskIntegrationRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListServiceDeskIntegrationsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* repeated c1.api.external_ticketing.v1.ServiceDeskIntegrationRef refs = 3; */
        for (let i = 0; i < message.refs.length; i++)
            ServiceDeskIntegrationRef.internalBinaryWrite(message.refs[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.v1.ListServiceDeskIntegrationsRequest
 */
export const ListServiceDeskIntegrationsRequest = new ListServiceDeskIntegrationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListServiceDeskIntegrationsResponse$Type extends MessageType<ListServiceDeskIntegrationsResponse> {
    constructor() {
        super("c1.api.external_ticketing.v1.ListServiceDeskIntegrationsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GetServiceDeskIntegrationResponse },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListServiceDeskIntegrationsResponse>): ListServiceDeskIntegrationsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListServiceDeskIntegrationsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListServiceDeskIntegrationsResponse): ListServiceDeskIntegrationsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.external_ticketing.v1.GetServiceDeskIntegrationResponse list */ 1:
                    message.list.push(GetServiceDeskIntegrationResponse.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListServiceDeskIntegrationsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.external_ticketing.v1.GetServiceDeskIntegrationResponse list = 1; */
        for (let i = 0; i < message.list.length; i++)
            GetServiceDeskIntegrationResponse.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.v1.ListServiceDeskIntegrationsResponse
 */
export const ListServiceDeskIntegrationsResponse = new ListServiceDeskIntegrationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateIntegrationNameRequest$Type extends MessageType<UpdateIntegrationNameRequest> {
    constructor() {
        super("c1.api.external_ticketing.v1.UpdateIntegrationNameRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateIntegrationNameRequest>): UpdateIntegrationNameRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.displayName = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateIntegrationNameRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateIntegrationNameRequest): UpdateIntegrationNameRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateIntegrationNameRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.v1.UpdateIntegrationNameRequest
 */
export const UpdateIntegrationNameRequest = new UpdateIntegrationNameRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateIntegrationNameResponse$Type extends MessageType<UpdateIntegrationNameResponse> {
    constructor() {
        super("c1.api.external_ticketing.v1.UpdateIntegrationNameResponse", []);
    }
    create(value?: PartialMessage<UpdateIntegrationNameResponse>): UpdateIntegrationNameResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateIntegrationNameResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateIntegrationNameResponse): UpdateIntegrationNameResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateIntegrationNameResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.v1.UpdateIntegrationNameResponse
 */
export const UpdateIntegrationNameResponse = new UpdateIntegrationNameResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServiceDeskIntegration$Type extends MessageType<ServiceDeskIntegration> {
    constructor() {
        super("c1.api.external_ticketing.v1.ServiceDeskIntegration", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "base_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "type", kind: "enum", T: () => ["c1.api.external_ticketing.v1.ServiceDeskType", ServiceDeskType] },
            { no: 4, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 100, name: "jira_config", kind: "message", oneof: "config", T: () => JiraConfig }
        ]);
    }
    create(value?: PartialMessage<ServiceDeskIntegration>): ServiceDeskIntegration {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.baseUrl = "";
        message.type = 0;
        message.displayName = "";
        message.config = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<ServiceDeskIntegration>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ServiceDeskIntegration): ServiceDeskIntegration {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string base_url */ 2:
                    message.baseUrl = reader.string();
                    break;
                case /* c1.api.external_ticketing.v1.ServiceDeskType type */ 3:
                    message.type = reader.int32();
                    break;
                case /* string display_name */ 4:
                    message.displayName = reader.string();
                    break;
                case /* c1.api.external_ticketing.jira.v1.JiraConfig jira_config */ 100:
                    message.config = {
                        oneofKind: "jiraConfig",
                        jiraConfig: JiraConfig.internalBinaryRead(reader, reader.uint32(), options, (message.config as any).jiraConfig)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ServiceDeskIntegration, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string base_url = 2; */
        if (message.baseUrl !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.baseUrl);
        /* c1.api.external_ticketing.v1.ServiceDeskType type = 3; */
        if (message.type !== 0)
            writer.tag(3, WireType.Varint).int32(message.type);
        /* string display_name = 4; */
        if (message.displayName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.displayName);
        /* c1.api.external_ticketing.jira.v1.JiraConfig jira_config = 100; */
        if (message.config.oneofKind === "jiraConfig")
            JiraConfig.internalBinaryWrite(message.config.jiraConfig, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.v1.ServiceDeskIntegration
 */
export const ServiceDeskIntegration = new ServiceDeskIntegration$Type();
/**
 * @generated ServiceType for protobuf service c1.api.external_ticketing.v1.ExternalTicketService
 */
export const ExternalTicketService = new ServiceType("c1.api.external_ticketing.v1.ExternalTicketService", [
    { name: "GetServiceDeskIntegration", options: { "authz.method": { role: "VIEWER" } }, I: GetServiceDeskIntegrationRequest, O: GetServiceDeskIntegrationResponse },
    { name: "ListServiceDeskIntegrations", options: { "authz.method": { role: "VIEWER" } }, I: ListServiceDeskIntegrationsRequest, O: ListServiceDeskIntegrationsResponse },
    { name: "CreateServiceDeskRef", options: { "authz.method": { role: "EDITOR" } }, I: CreateServiceDeskRefRequest, O: CreateServiceDeskRefResponse },
    { name: "GetServiceDeskRef", options: { "authz.method": { role: "VIEWER" } }, I: GetServiceDeskRefRequest, O: GetServiceDeskRefResponse },
    { name: "DeleteServiceDeskRef", options: { "authz.method": { role: "EDITOR" } }, I: DeleteServiceDeskRefRequest, O: DeleteServiceDeskRefResponse },
    { name: "UpdateIntegrationName", options: { "authz.method": { role: "EDITOR" } }, I: UpdateIntegrationNameRequest, O: UpdateIntegrationNameResponse },
    { name: "UpdateConfig", options: { "authz.method": { role: "EDITOR" } }, I: UpdateConfigRequest, O: UpdateConfigResponse }
]);
